import { getCampLocations } from '../firebase/firebase';
import { useState, useEffect} from 'react';
import styles from './calendar-style.module.css'
import { ReactComponent as ChautauquaArrowSVG } from './chautauqua-arrow.svg';


function EventTypeSelector({setVisibleEventTypes, visibleEventTypes}) {

    const onChecked = (type, visible) => {
        var vet = structuredClone(visibleEventTypes);
        vet[type] = visible;
        setVisibleEventTypes(vet);
    }

    return (
        <div id={styles.event_type}>
            <h2>Calendar Event Type</h2>
            <label>
                <input type="checkbox" id="view-camps" defaultChecked={true} onChange={(ev) => onChecked('camp', ev.target.checked)}></input>
                Camps
            </label>
            <label>
                <input type="checkbox" id="view-retreats" defaultChecked={true} onChange={(ev) => onChecked('retreat', ev.target.checked)}></input>
                Retreats
            </label>
            <label>
                <input type="checkbox" id="view-day-events" defaultChecked={true} onChange={(ev) => onChecked('day_event', ev.target.checked)}></input>
                Day Events
            </label>
            <label>
                <input type="checkbox" id="view-reservations" defaultChecked={true} onChange={(ev) => onChecked('reservation', ev.target.checked)}></input>
                Reservations
            </label>
            
        </div>       
    );
}

function LocationsReservedFilter({setLocationFilters, locationsFilters, dropdownVisibily, setDropdownVisibily}) {

    const [locations, setLocations] = useState([]);

    useEffect(() => {
        getCampLocations().then((locations) => {setLocations(locations)})
    }, [setLocations]);

    const onCheckboxChanged = (checked, location) => {
        if(checked) {
            setLocationFilters([...locationsFilters, location])
        } else {
            let index = locationsFilters.indexOf(location);

            if(index >= 0)
                locationsFilters.splice(index, 1);

            setLocationFilters([...locationsFilters]);
        }
    }

    var labelText = "No Locations Selected";

    if(locationsFilters.length >= 2)
        labelText = `${locationsFilters.length} Location${locationsFilters.length===1 ? '' : 's'} Selected`;
    else if (locationsFilters.length === 1)
        labelText = `${locationsFilters[0].split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}`;


    return (
        <div id={styles.locations}>
            <h2>Locations Reserved</h2>
            <div id={styles.location_selector} onClick={() => setDropdownVisibily(!dropdownVisibily)}>
                {labelText}
                <ChautauquaArrowSVG fill="#000000" id={styles.right}/>
            </div>
            <div id={styles.location_checkboxes} style={{display: (dropdownVisibily) ? 'flex' : 'none'}}>
                {
                    locations.map(
                        (location) => {
                            let tag = location.toLocaleLowerCase().replaceAll(' ', '-')
                            return (
                            <label key={tag} htmlFor={tag}>
                                <input type="checkbox" id={tag} onChange={(ev) => onCheckboxChanged(ev.target.checked, tag)}/>
                                {` ${location}`}
                            </label>)
                        }
                    )
                }
            </div>
        </div>      
    );
}


function CalendarFilter({setVisibleEventTypes, visibleEventTypes, setLocationFilters, locationsFilters, dropdownVisibily, setDropdownVisibily}) {
    return (
        <div id={styles.filter_panel}>
            <h1>Filters</h1>
            <div style={{display: 'flex', flexDirection: 'row'}}>
                <EventTypeSelector setVisibleEventTypes={setVisibleEventTypes} visibleEventTypes={visibleEventTypes}/>
                <LocationsReservedFilter setLocationFilters={setLocationFilters} locationsFilters={locationsFilters}
                    dropdownVisibily={dropdownVisibily} setDropdownVisibily={setDropdownVisibily}/>
            </div>
        </div>
    );
}

export default CalendarFilter;